import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { AuthProvider } from "./components/context/AuthContext";
import ProtectedRoute from "./components/context/ProtectedRoute";
import Contracts from "./components/contracts/Contracts";
import GenerateContract from "./components/contracts/generate-contract/GenerateContract";
import CreateContract from "./components/create-contract/CreateContract";
import BulkUploadForm from "./components/create-contract/forms/BulkUploadForm";
import ManualCreateForm from "./components/create-contract/forms/ManualCreateForm";
import Dashboard from "./components/dashboard/Dashboard";
import Home from "./components/home/Home";
import Login from "./components/login/Login";
import Logs from "./components/logs/Logs";
import Navbar from "./components/navbar/Navbar";
import Register from "./components/register/Register";
import TextEditor from "./components/text-editor/TextEditor";
import AccessDenied from "./components/users/AccessDenied";
import CreateUser from "./components/users/CreateUser";
import UpdateUser from "./components/users/UpdateUser";
import UserPofile from "./components/users/UserPofile";
import Users from "./components/users/Users";
import TenantManager from "./components/tenants/TenantManager";
import ResetPassword from "./components/login/ResetPassword";
import ForgotPassword from "./components/login/ForgotPassword";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/accessdenied" element={<AccessDenied />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/create-contract"
            element={
              <ProtectedRoute role={["admin", "staff"]}>
                <CreateContract />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bulk-upload-form"
            element={
              <ProtectedRoute role={["admin", "staff"]}>
                <BulkUploadForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manual-create-form"
            element={
              <ProtectedRoute role={["admin", "staff"]}>
                <ManualCreateForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contracts"
            element={
              <ProtectedRoute>
                <Contracts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tenant-manager"
            element={
              <ProtectedRoute>
                <TenantManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/generate-contract"
            element={
              <ProtectedRoute role={["admin"]}>
                <GenerateContract />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute role={["admin"]}>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/userprofile"
            element={
              <ProtectedRoute>
                <UserPofile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/create"
            element={
              <ProtectedRoute role={["admin"]}>
                <CreateUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit/:id"
            element={
              <ProtectedRoute role={["admin"]}>
                <UpdateUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/:id"
            element={
              <ProtectedRoute>
                <TextEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/new"
            element={
              <ProtectedRoute>
                <TextEditor createNew />
              </ProtectedRoute>
            }
          />
          <Route
            path="/logs"
            element={
              <ProtectedRoute role={["admin"]}>
                <Logs />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
